import { authenticatedFetch } from './request';

export default async function getCity(setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las ciudades.');
    return await authenticatedFetch('/cities/getList', onError);
}
